import { Column2 } from "@/ui2/atoms/(table)/Column";
import { TableHeader2 } from "@/ui2/molecules/(table)/TableHeader";

type CosignatureTableHeaderProps = {
  isDisabled?: boolean;
};

export function CosignatureTableHeader({ isDisabled }: CosignatureTableHeaderProps) {
  return (
    <TableHeader2 isSelectionDisabled={isDisabled}>
      {TABLE_HEADER_ITEMS.map((header, index) => (
        <Column2
          allowsSorting={header.isSortable}
          id={header.id}
          isRowHeader={index === 0}
          key={header.id}
        >
          {header.label}
        </Column2>
      ))}
    </TableHeader2>
  );
}

type TableHeaderItem = {
  id: string;
  isSortable: boolean;
  label: string;
};

const TABLE_HEADER_ITEMS = [
  { id: "submittedBy", isSortable: true, label: "Submitted By" },
  { id: "patientName", isSortable: true, label: "Patient Name" },
  { id: "type", isSortable: true, label: "Type" },
  { id: "dateSigned", isSortable: true, label: "Date Signed" },
  { id: "status", isSortable: true, label: "Status" },
  { id: "action", isSortable: false, label: "Action" },
] satisfies TableHeaderItem[];
